module.exports = __webpack_public_path__ + "img/icono-terminal.705d2d13.svg";